import { Tabs } from '@mantine/core';
import type { Market } from '../types';

interface MarketTabsProps {
  value: Market | 'all';
  onChange: (value: Market | 'all') => void;
  counts: {
    all: number;
    canada: number;
    usa: number;
  };
}

export function MarketTabs({ value, onChange, counts }: MarketTabsProps) {
  return (
    <Tabs
      value={value}
      onChange={(v) => onChange(v as Market | 'all')}
      variant="pills"
    >
      <Tabs.List>
        <Tabs.Tab value="all">All ({counts.all})</Tabs.Tab>
        <Tabs.Tab value="canada">Canada ({counts.canada})</Tabs.Tab>
        <Tabs.Tab value="usa">USA ({counts.usa})</Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
